import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Exclusive from "../views/Exclusive.vue";
import ImgNumSay from "../views/ImgNumSay.vue";
import China from "../views/China.vue";
import CharacterStory from "../views/CharacterStory.vue";
import Beautiful from "../views/Beautiful.vue";
import Classroom from "../views/Classroom.vue";
import Periodicals from "../views/Periodicals.vue";
import ArticleDetail from "../views/ArticleDetail.vue";
import ArticleDetail2 from "../views/ArticleDetail2.vue";
// import ChuXin from "../views/ChuXin.vue";
import Events from "../views/Events.vue";
// import ZhongGuoGuShi from "../views/ZhongGuoGuShi.vue";
import News from "../views/News.vue";
import Governance from "../views/Governance.vue";

import GovernanceDetail from "../views/GovernanceDetail.vue";
// import ZhuanTiBaoDao from "../views/ZhuanTiBaoDao.vue";
import PublishNews from "../views/PublishNews.vue";
// import DiQiuCun from "../views/DiQiuCun.vue";
import PublishList from "../views/PublishList.vue";
// import YuanShi from "../views/YuanShi.vue";
import Login from "../views/Login.vue";
// import YiLuTongXing from "../views/YiLuTongXing.vue";
import PublishEvents from "../views/PublishEvents.vue";


import StrategyPlan from "../views/StrategyPlan.vue";
import Program from "../views/Program.vue";
import MultimediaGallery from "../views/MultimediaGallery.vue";
import Partnership from "../views/Partnership.vue";
import Membership from "../views/Membership.vue";
import About from "../views/About.vue";
import AboutWorld from "../views/AboutWorld.vue";
import AboutSession from "../views/AboutSession.vue";
import Clubs from "../views/Clubs.vue";
import Publish from "../views/Publish.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {

      isShow: true,
      title: "Home",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  {
    path: "/publish",
    name: "Publish",
    component: Publish,
    meta: {
      isShow: true,
      title: "Publish",
      content: {
        keywords: "",
        description: "",
      },
    },
  }, {
    path: "/partnership",
    name: "Partnership",
    component: Partnership,
    meta: {
      isShow: true,
      title: "Partnership",
      content: {
        keywords: "",
        description: "",
      },
    },
  }, {
    path: "/clubs",
    name: "Clubs",
    component: Clubs,
    meta: {
      isShow: true,
      title: "UNESCO Clubs Movement",
      content: {
        keywords: "",
        description: "",
      },
    },
  }, {
    path: "/us",
    name: "About",
    component: About,
    meta: {
      isShow: true,
      title: "About",
      content: {
        keywords: "",
        description: "",
      },
    },
  },{
    path: "/AboutWorld",
    name: "AboutWorld",
    component: AboutWorld,
    meta: {
      isShow: true,
      title: "AboutWorld",
      content: {
        keywords: "",
        description: "",
      },
    },
  },{
    path: "/AboutSession",
    name: "AboutSession",
    component: AboutSession,
    meta: {
      isShow: true,
      content: {
        keywords: "",
        description: "",
      },
    },
  }, {
    path: "/membership",
    name: "Membership",
    component: Membership,
    meta: {
      isShow: true,
      title: "Membership",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/strategy",
    name: "StrategyPlan",
    component: StrategyPlan,
    meta: {
      isShow: true,
      title: "Strategy & Plan",
      content: {
        keywords: "",
        description: "",
      },
    },
  }, {
    path: "/program",
    name: "Program",
    component: Program,
    meta: {
      isShow: true,
      title: "Program",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/multimedia",
    name: "MultimediaGallery",
    component: MultimediaGallery,
    meta: {
      isShow: true,
      title: "Multimedia Gallery",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/events",
    name: "Events",
    component: Events,
    meta: {
      isShow: true,
      title: "News & Events",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/news",
    name: "News",
    component: News,
    meta: {
      isShow: true,
      title: "News & Events",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/governanceDetail",
    name: "GovernanceDetail",
    component: GovernanceDetail,
    meta: {
      isShow: true,
      title: "本刊评论",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/publishnews",
    name: "PublishNews",
    component: PublishNews,
    meta: {
      isShow: true,
      title: "专题报道",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/publishlist",
    name: "PublishList",
    component: PublishList,
    meta: {
      isShow: true,
      title: "地球村面孔",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      isShow: true,
      title: "院士与中国",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/publishevents",
    name: "PublishEvents",
    component: PublishEvents,
    meta: {
      isShow: true,
      title: "一路同行",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  // 卷首发布
  {
    path: "/governance",
    name: "Governance",
    component: Governance,
    meta: {
      isShow: true,
      title: "首卷发布",
      content: {
        keywords: "",
        description:
          "",
      },
    },
  },
  {
    path: "/zggjc",
    name: "Exclusive",
    component: Exclusive,
    meta: {
      isShow: true,
      title: "中国关键词",
      content: {
        keywords: "",
        description:
          "",
      },
    },
  },
  {
    path: "/fbjl",
    name: "ImgNumSay",
    component: ImgNumSay,
    meta: {
      isShow: true,
      title: "发布精览",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/sdjd",
    name: "China",
    component: China,
    meta: {
      isShow: true,
      title: "深度解读",
      content: {
        keywords: "",
        description:
          "",
      },
    },
  },
  {
    path: "/xsddzgr",
    name: "CharacterStory",
    component: CharacterStory,
    meta: {
      isShow: true,
      title: "新时代的中国人",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/xzc",
    name: "Beautiful",
    component: Beautiful,
    meta: {
      isShow: true,
      title: "新征程",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/ddzg",
    name: "Classroom",
    component: Classroom,
    meta: {
      isShow: true,
      title: "读懂中国",
      content: {
        keywords: "",
        description: "",
      },
    },
  },
  {
    path: "/articleDetail",
    name: "ArticleDetail",
    component: ArticleDetail,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/articleDetail2",
    name: "ArticleDetail2",
    component: ArticleDetail2,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/search",
    name: "Search",
    component: () => import(/* webpackChunkName: "about" */ "../views/Search.vue"),
    meta: {
      keepAlive: false,
    },
  },

  {
    path: "/about",
    name: "About",
    meta: {
      isShow: true,
      title: "World Federation",
      content: {
        keywords: "",
        description: "",
      },
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

// const routes = [
//   {
//     path: "/",
//     name: "Home",
//     component: Home,
//     meta: {
//       isShow: true,
//       title: "首页",
//       content: {
//         keywords: "中国新闻发布,首页",
//         description: "中国新闻发布首页",
//       },
//     },
//   },
//   {
//     path: "/cxsm",
//     name: "ChuXin",
//     component: ChuXin,
//   },
//   {
//     path: "/wdzggs",
//     name: "ZhongGuoGuShi",
//     component: ZhongGuoGuShi,
//   },
//   {
//     path: "/benkanpinglun",
//     name: "BenKanPingLun",
//     component: BenKanPingLun,
//   },
//   {
//     path: "/ydyl",
//     name: "YiDaiYiLuQiYe",
//     component: YiDaiYiLuQiYe,
//   },
//   {
//     path: "/ztbd",
//     name: "ZhuanTiBaoDao",
//     component: ZhuanTiBaoDao,
//   },
//   {
//     path: "/dqcmk",
//     name: "DiQiuCun",
//     component: DiQiuCun,
//   },
//   {
//     path: "/yuanshiyuzg",
//     name: "YuanShi",
//     component: YuanShi,
//   },
//   {
//     path: "/zhiyuanzg",
//     name: "ZhiYuanZhongGuo",
//     component: ZhiYuanZhongGuo,
//   },
//   {
//     path: "/yilutongxing",
//     name: "YiLuTongXing",
//     component: YiLuTongXing,
//   },
//   {
//     path: "/zhonghuazm",
//     name: "ZhongHuaZhiMei",
//     component: ZhongHuaZhiMei,
//   },
//   // 卷首发布
//   {
//     path: "/jsfb",
//     name: "jsfb",
//     component: FirstRound,
//   },
//   {
//     path: "/zggjc",
//     name: "Exclusive",
//     component: Exclusive,
//   },
//   {
//     path: "/fbjl",
//     name: "ImgNumSay",
//     component: ImgNumSay,
//   },
//   {
//     path: "/sdjd",
//     name: "China",
//     component: China,
//   },
//   {
//     path: "/xsddzgr",
//     name: "CharacterStory",
//     component: CharacterStory,
//   },
//   {
//     path: "/xzc",
//     name: "Beautiful",
//     component: Beautiful,
//   },
//   {
//     path: "/wzyy",
//     name: "WuZhou",
//     component: WuZhou,
//   },
//   {
//     path: "/ddzg",
//     name: "Classroom",
//     component: Classroom,
//   },
//   {
//     path: "/zxdk",
//     name: "Periodicals",
//     component: Periodicals,
//   },
//   {
//     path: "/articleDetail",
//     name: "ArticleDetail",
//     component: ArticleDetail,
//     meta: {
//       keepAlive: false,
//     },
//   },
//   {
//     path: "/search",
//     name: "Search",
//     component: () => import(/* webpackChunkName: "about" */ "../views/Search.vue"),
//     meta: {
//       keepAlive: false,
//     },
//   },
//   {
//     path: "/book",
//     name: "Book",
//     component: () => import(/* webpackChunkName: "about" */ "../views/Book.vue"),
//     meta: {
//       keepAlive: false,
//     },
//   },

//   {
//     path: "/about",
//     name: "About",
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
//   },
// ];

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
